<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">修改密码</span>
    </h2>
    <div class="list-content">
      <el-form :model="labelForm" :rules="rules" ref="labelForm" label-width="100px" class="label-form">
        <el-form-item prop="oldPassword" label="原密码">
          <el-input v-model="labelForm.oldPassword" type="password" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码">
          <el-input v-model="labelForm.newPassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword2" label="确认新密码">
          <el-input v-model="labelForm.newPassword2" type="password" placeholder="请确认新密码"></el-input>
        </el-form-item>
        <el-form-item>
          <span class="pwd_hint">密码支持8～16位大小写字母和数字的组合</span>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width:100%"
            :class="disloginBtn ? 'disloginBtn' : ''"
            @click="submitForm('labelForm')"
          >
            提交
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { Form, FormItem, Input, Button } from 'element-ui';
import Vue from 'vue';
import Fetch from '@/api';
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
export default {
  data() {
    return {
      labelForm: {},
      rules: {
        oldPassword: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(Error('原密码不能为空'));
              } else if (!/^(?![0-9]+$)(?![A-Za-z]+$)[0-9A-Za-z]{8,16}$/.test(value)) {
                callback(Error('密码由8～16位大小写字母和数字组成'));
              } else {
                callback();
              }
            },
            required: true,
            trigger: 'blur'
          }
        ],
        newPassword: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(Error('新密码不能为空'));
              } else if (!/^(?![0-9]+$)(?![A-Za-z]+$)[0-9A-Za-z]{8,16}$/.test(value)) {
                callback(Error('密码由8～16位大小写字母和数字组成'));
              } else {
                callback();
              }
            },
            required: true,
            trigger: 'blur'
          }
        ],
        newPassword2: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(Error('确认密码不能为空'));
              } else if (value !== this.labelForm.newPassword) {
                callback(Error('新密码和确认密码需保持一致'));
              } else {
                callback();
              }
            },
            required: true,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    disloginBtn() {
      const { oldPassword, newPassword, newPassword2 } = this.labelForm;
      return !oldPassword || !newPassword || !newPassword2;
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const { oldPassword, newPassword } = this.labelForm;
          const params = {
            oldPassword,
            newPassword
          };
          Fetch.updatePassword(params).then(res => {
            this.$message.success('修改成功');
            Fetch.logOut().then(() => {
              // 用户退出后刷新清除所有数据 确保不会产生异常行为
              this.$router.replace({ name: 'Login' }, () => {
                location.reload();
              });
            });
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
  min-height: 600px;
  .label-form {
    width: 320px;
    height: auto;
    margin-top: 50px;
    .pwd_hint {
      line-height: 20px;
      display: inline-block;
    }
    .disloginBtn {
      color: rgba(255, 255, 255, 0.5);
      cursor: not-allowed;
    }
  }
}
</style>
